import React, { forwardRef, useCallback, useEffect, useRef, useState, } from "react";
import { digitsToHindi } from "../../../utils/numbers";
import { ErrorMessage, HelpMessage } from "./InfoMessages";
import { Resize } from "../../../icons";
import TextareaAutosize from "react-textarea-autosize";
import classnames from "classnames";
import styles from "./TextField.module.scss";
import classNames from "classnames";
import { useCombineRefs } from "../../../hooks";
const TextFieldFC = (props, ref) => {
    var _a, _b, _c;
    const { formatNumber } = props;
    const [direction, setDirection] = useState("rtl");
    const [isFocus, setIsFocus] = useState(false);
    const textAreaRef = useRef(null);
    const fieldRef = useCombineRefs(textAreaRef, ref);
    const focusHandler = useCallback((e) => {
        var _a;
        setIsFocus(true);
        (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }, [props.onFocus]);
    const blurHandler = useCallback((e) => {
        var _a;
        setIsFocus(false);
        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }, [props.onBlur]);
    useEffect(() => {
        if (props.multiline) {
            const dir = getComputedStyle(textAreaRef.current).direction;
            if (dir !== direction) {
                setDirection(dir);
            }
        }
    }, [props.value]);
    useEffect(() => {
        if (props.cursorStart != null && textAreaRef.current) {
            textAreaRef.current.setSelectionRange(props.cursorStart, props.cursorStart);
        }
    }, [props.cursorStart]);
    return (React.createElement("div", { className: classnames(props.className, styles.wrapper), onClick: props.onWrapperClick },
        React.createElement("div", { className: classnames("field-wrapper", styles.FieldWrapper, {
                [styles.isFoucs]: isFocus,
                [styles.hasError]: props.error != null,
                [styles.disabled]: props.disabled,
            }) },
            props.suffix,
            props.label && (React.createElement("label", { className: styles.label, style: { backgroundColor: props.labelBG }, htmlFor: props.label }, props.label)),
            props.multiline ? (React.createElement("div", { className: styles.TextAreaWrapper },
                props.resize !== false && (React.createElement("div", { className: classNames({
                        [styles.rtl]: direction === "rtl",
                        [styles.ltr]: direction === "ltr",
                    }, styles.ResizeWrapper) },
                    React.createElement(Resize, { size: 10 }))),
                React.createElement(TextareaAutosize, { className: styles.TextArea, ref: fieldRef, id: props.label, value: props.value, name: props.name, placeholder: props.placeholder, onChange: (event) => props.onChange(event.target.value, event.target), disabled: props.disabled, rows: props.rows, onFocus: focusHandler, onBlur: blurHandler, onKeyDown: props.onKeyDown, onKeyUp: props.onKeyUp, maxLength: props.maxLength, maxRows: props.maxRows, readOnly: props.readOnly, style: {
                        minBlockSize: props.minHeight,
                        maxBlockSize: props.maxHeight,
                        paddingInlineEnd: props.hasPrefixSuffix ? "50px" : "14px",
                    } }))) : (React.createElement("div", { className: styles.InputWrapper },
                React.createElement("input", { className: styles.input, id: props.label, ref: fieldRef, type: (_a = props.type) !== null && _a !== void 0 ? _a : "text", name: props.name, autoFocus: props.autoFocus, inputMode: props.inputMode, value: props.value, autoComplete: (_b = props.autoComplete) !== null && _b !== void 0 ? _b : "off", onKeyDown: props.onKeyDown, onKeyUp: props.onKeyUp, placeholder: props.placeholder, onChange: (event) => props.onChange(event.target.value, event.target), disabled: props.disabled, pattern: props.pattern, onFocus: focusHandler, onBlur: blurHandler, maxLength: props.maxLength, dir: props.dir ? props.dir : "auto", "data-testid": (_c = props["data-testid"]) !== null && _c !== void 0 ? _c : "textfield-single-line-input", readOnly: props.readOnly }),
                props.prefix))),
        (props.max || props.error) && (React.createElement("div", { className: styles.MessageWrapper },
            props.error && (React.createElement(ErrorMessage, { "data-testid": "textfield-error", message: props.error })),
            props.max && (React.createElement("div", { className: styles.max }, formatNumber
                ? formatNumber(`${props.value.length}/${props.max}`) + " "
                : digitsToHindi(`${props.value.length}/${props.max}`) + " ")))),
        props.helpText && React.createElement(HelpMessage, { message: props.helpText })));
};
/** @deprecated Use `NewTextField` instead */
export const TextField = forwardRef(TextFieldFC);
//# sourceMappingURL=TextField.js.map